import _typeof from "@babel/runtime/helpers/typeof";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Calendar from 'react-calendar';
import throttle from 'lodash/throttle';
import OutsideClickHandler from '@pattern-library/outside-click-handler';
import { CalendarIcon, ChevronRightBoldIcon, ChevronLeftBoldIcon, ErrorBoldIcon, WarningBoldIcon } from '@pattern-library/icon';
import { FormLabelPopover } from '@pattern-library/message-popover';
import { FocusService } from '@pattern-library/utils';
var DatePicker = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DatePicker, _Component);
  function DatePicker(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.clearDateValue = function () {
      _this.setState({
        date: null,
        inputVal: '',
        visibleMonth: null,
        dateSelectionAnnouncementContent: 'no date selected'
      });
    };
    _this.setTabIndicies = function () {
      var datepickerEl = _this.datepickerRef.current;
      if (datepickerEl) {
        var allTiles = datepickerEl.querySelectorAll('.react-calendar__tile');
        allTiles === null || allTiles === void 0 ? void 0 : allTiles.forEach(function (day, index) {
          day.tabIndex = -1;
          day.onkeydown = function (e) {
            return _this.handleTileKeydown(e, index, allTiles);
          };
        });
        var activeTile = datepickerEl.querySelector('.react-calendar__tile--active:not([disabled])');
        var todayTile = datepickerEl.querySelector('.react-calendar__tile--now:not([disabled])');
        if (activeTile) {
          activeTile.tabIndex = 0;
        } else if (todayTile) {
          todayTile.tabIndex = 0;
        } else {
          var firstTile = datepickerEl.querySelector('.react-calendar__tile:not([disabled]):not(.react-calendar__month-view__days__day--neighboringMonth)');
          if (firstTile) {
            firstTile.tabIndex = 0;
          }
        }
      }
    };
    _this.handleTileKeydown = function (e, currentlyFocusedTileIndex, allTiles) {
      var keyCodes = {
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
      };
      if (e.keyCode >= keyCodes.LEFT && e.keyCode <= keyCodes.DOWN) {
        e.preventDefault();
        var totalNumberOfTiles = allTiles.length;
        var newTileIndex;
        if (e.keyCode === keyCodes.LEFT) {
          newTileIndex = (currentlyFocusedTileIndex + totalNumberOfTiles - 1) % totalNumberOfTiles;
        } else if (e.keyCode === keyCodes.RIGHT) {
          newTileIndex = (currentlyFocusedTileIndex + 1) % totalNumberOfTiles;
        } else if (e.keyCode === keyCodes.UP) {
          newTileIndex = (currentlyFocusedTileIndex + totalNumberOfTiles - 7) % totalNumberOfTiles;
        } else if (e.keyCode === keyCodes.DOWN) {
          newTileIndex = (currentlyFocusedTileIndex + 7) % totalNumberOfTiles;
        }
        var tileToBeFocused = allTiles[newTileIndex];
        if (tileToBeFocused !== null && tileToBeFocused !== void 0 && tileToBeFocused.disabled) {
          _this.handleTileKeydown(e, newTileIndex, allTiles);
        }
        FocusService.focusElement(tileToBeFocused);
      }
    };
    _this.positionDatepicker = function () {
      var datepickerRef = _this.datepickerRef.current;
      var inputRef = _this.inputRef.current;
      var viewportWidth = Math.min(window.outerWidth, window.innerWidth);
      var viewportHasChanged = viewportWidth !== _this.state.viewportWidth;
      var useFixedPositioning = _this.canUsePortal;
      var calendarPosition = {};
      if (inputRef && useFixedPositioning) {
        var _inputRef$getBounding = inputRef.getBoundingClientRect(),
          left = _inputRef$getBounding.left,
          bottom = _inputRef$getBounding.bottom;
        var hasError = Boolean(_this.state.errorMessage);
        var inputBottom = Math.round(bottom);
        calendarPosition = {
          top: hasError ? inputBottom + 10 : inputBottom,
          left: Math.round(left)
        };
      }
      if (datepickerRef && viewportHasChanged) {
        var datepicker = datepickerRef.querySelector('.react-calendar');
        var bounds = datepicker.getBoundingClientRect();
        var overflowsRight = bounds.left + bounds.width > viewportWidth;

        // center datepicker if it overflows the right edge of the viewport
        _this.setState({
          calendarPosition: calendarPosition,
          centerDatepicker: overflowsRight,
          viewportWidth: viewportWidth
        });
      } else if (datepickerRef && useFixedPositioning) {
        _this.setState({
          calendarPosition: calendarPosition
        });
      }
    };
    _this.setDateValue = function (date) {
      var _this$props = _this.props,
        alwaysOpen = _this$props.alwaysOpen,
        closeOnDateSelection = _this$props.closeOnDateSelection,
        onDateSelection = _this$props.onDateSelection;
      var inputVal = date ? date.toLocaleDateString('en-US') : '';
      var dateSelectionAnnouncementContent = date ? "".concat(date.toDateString(), " selected") : 'no date selected';
      var visibleMonth = date || _this.state.visibleMonth;
      _this.setState({
        date: date,
        inputVal: inputVal,
        dateSelectionAnnouncementContent: dateSelectionAnnouncementContent,
        visibleMonth: visibleMonth
      }, function () {
        this.setTabIndicies();
      });
      onDateSelection(date);
      if (!alwaysOpen && closeOnDateSelection) {
        _this.hideDatepicker();
      }
    };
    _this.formatStringsToDates = function (dates) {
      return dates.map(function (date) {
        return new Date(date);
      });
    };
    _this.isDayBlocked = function (day) {
      var _this$props2 = _this.props,
        blockWeekends = _this$props2.blockWeekends,
        blockedDates = _this$props2.blockedDates;
      if (blockWeekends) {
        var dayValue = new Date(day).getDay();
        if (dayValue === 0 || dayValue === 6) {
          return true;
        }
      }
      if (_this.isOutsideRange(day)) {
        return true;
      }
      if (!blockedDates.length) {
        return false;
      }
      return _this.formatStringsToDates(blockedDates).some(function (blockedDate) {
        return _this.isSameDate(new Date(blockedDate), day);
      });
    };
    _this.isOutsideRange = function (day) {
      var _this$props3 = _this.props,
        maxDate = _this$props3.maxDate,
        minDate = _this$props3.minDate;
      var isAfterMaxDate = false;
      var isBeforeMinDate = false;
      var date = new Date(day);
      if (maxDate) {
        isAfterMaxDate = date > new Date(maxDate);
      }
      if (minDate) {
        isBeforeMinDate = date < new Date(minDate);
      }
      return isBeforeMinDate || isAfterMaxDate;
    };
    _this.isDateValid = function (date) {
      // MM/dd/yyyy
      var date_regex = /^(0[1-9]|1[0-2]|[1-9])\/(0[1-9]|1\d|2\d|3[01]|[1-9])\/\d{4}$/;
      return date_regex.test(date);
    };
    _this.checkValidity = function (inputVal, date) {
      var _this$props4 = _this.props,
        minDate = _this$props4.minDate,
        maxDate = _this$props4.maxDate,
        errorBlockedDate = _this$props4.errorBlockedDate,
        errorOutsideRange = _this$props4.errorOutsideRange,
        errorInvalid = _this$props4.errorInvalid;
      var isValidDate = _this.isDateValid(inputVal);
      if (isValidDate && _this.isOutsideRange(date)) {
        // date is outside allowed range
        var rangeErrorMsg = errorOutsideRange;
        var minDateFormat = minDate ? new Date(minDate).toLocaleDateString('en-US') : '';
        var maxDateFormat = maxDate ? new Date(maxDate).toLocaleDateString('en-US') : '';
        if (minDate && maxDate) rangeErrorMsg += " (".concat(minDateFormat, " to ").concat(maxDateFormat, ")");else if (minDate) rangeErrorMsg += " (before ".concat(minDateFormat, ")");else if (maxDate) rangeErrorMsg += " (after ".concat(maxDateFormat, ")");
        _this.setCustomValidityError(rangeErrorMsg);
        return false;
      } else if (isValidDate && _this.isDayBlocked(date)) {
        // date is blocked
        _this.setCustomValidityError(errorBlockedDate);
        return false;
      } else if (!isValidDate) {
        // date is invalid
        _this.setCustomValidityError(errorInvalid);
        return false;
      } else if (_this.setCustomError()) {
        return true;
      }

      // date is valid, clear error message
      _this.setCustomValidityError('');
      return true;
    };
    _this.setCustomError = function () {
      var _this$props5 = _this.props,
        displayCustomError = _this$props5.displayCustomError,
        customErrorMessage = _this$props5.customErrorMessage;
      var errorMessage = displayCustomError ? customErrorMessage : '';
      _this.setCustomValidityError(errorMessage);
      return displayCustomError;
    };
    _this.setCustomValidityError = function (errorMessage) {
      _this.inputRef.current.setCustomValidity(errorMessage);
      _this.setState({
        errorMessage: errorMessage
      });
    };
    _this.isSameDate = function (date1, date2) {
      return date1.toLocaleDateString() === (date2 === null || date2 === void 0 ? void 0 : date2.toLocaleDateString());
    };
    _this.validateInput = function () {
      var _this$props6 = _this.props,
        isRequired = _this$props6.isRequired,
        errorRequired = _this$props6.errorRequired;
      var _this$state = _this.state,
        inputVal = _this$state.inputVal,
        visibleMonth = _this$state.visibleMonth;
      var date = null;
      var isSameValue = false;
      var isValid = true;
      if (inputVal) {
        date = new Date(inputVal);
        isValid = _this.checkValidity(inputVal, date);
        isSameValue = _this.isSameDate(date, _this.state.date);
      } else if (isRequired && !inputVal) {
        _this.setCustomValidityError(errorRequired);
      }
      if (!isSameValue && isValid) {
        _this.setDateValue(date);
      } else if (isValid) {
        // if the date is the same and valid, update the visible month
        _this.setState({
          visibleMonth: date || visibleMonth
        }, function () {
          this.setTabIndicies();
        });
      } else if (!isSameValue && !isValid) {
        _this.setState({
          date: null
        });
      }
    };
    _this.handleInputChange = function (e) {
      var inputVal = e.target.value.trim();
      _this.setState({
        inputVal: inputVal
      });
    };
    _this.handleInputKeydown = function (e) {
      if (e.keyCode === 13) {
        // ENTER
        _this.validateInput();
      }
    };
    _this.handleInputBlur = function () {
      _this.validateInput();
    };
    _this.handleIconClick = function (e) {
      e.preventDefault();
      var showDatepicker = _this.state.showDatepicker;
      if (showDatepicker) {
        _this.hideDatepicker();
      } else {
        _this.showDatepicker().then(function () {
          _this.positionDatepicker();
          _this.setTabIndicies();
          _this.setState({
            datepickerHasFocus: true
          }, function () {
            var datepickerEl = _this.datepickerRef.current;
            if (datepickerEl) {
              var selectedDay = datepickerEl.querySelector('.react-calendar__tile--active') || datepickerEl.querySelector('.react-calendar__tile--now');
              FocusService.focusElement(selectedDay);
            }
          });
        });
      }
    };
    _this.handleInputFocus = function () {
      var showDatepickerOnInputFocus = _this.props.showDatepickerOnInputFocus;
      var showDatepicker = _this.state.showDatepicker;
      if (showDatepickerOnInputFocus && !showDatepicker) {
        _this.showDatepicker();
      }
    };
    _this.handleDayPickerOnTab = function (e) {
      var alwaysOpen = _this.props.alwaysOpen;
      if (alwaysOpen) return;
      var TAB = 9;
      if (e.keyCode === TAB) {
        window.setTimeout(function () {
          var focusedElement = document.activeElement;
          var isFocusOutside = !_this.datepickerRef.current.contains(focusedElement);
          if (isFocusOutside) {
            _this.hideDatepicker();
          }
        }, 0);
      }
    };
    _this.focusOnInput = function () {
      if (_this.props.showInput && _this.inputRef.current) {
        _this.inputRef.current.focus();
      }
    };
    _this.showDatepicker = function () {
      return new Promise(function (resolve) {
        if (!_this.componentIsMounted) return;
        _this.setState({
          showDatepicker: true
        }, function () {
          _this.addEventListeners();
          resolve();
        });
      });
    };
    _this.addEventListeners = function () {
      if (_this.canUsePortal) {
        _this.removeEventListeners();
        _this.abortController = new AbortController();
        window.addEventListener('resize', throttle(_this.positionDatepicker, 10), {
          signal: _this.abortController.signal
        });
        window.addEventListener('scroll', throttle(_this.positionDatepicker, 10), {
          signal: _this.abortController.signal
        });
      }
    };
    _this.hideDatepicker = function () {
      return new Promise(function (resolve) {
        if (!_this.componentIsMounted) return;
        _this.setState({
          showDatepicker: false
        }, function () {
          _this.removeEventListeners();
          _this.focusOnInput();
          resolve();
        });
      });
    };
    _this.removeEventListeners = function () {
      if (_this.abortController) {
        _this.abortController.abort();
      }
    };
    _this.onActiveStartDateChange = function (_ref) {
      var action = _ref.action,
        activeStartDate = _ref.activeStartDate;
      var visibleMonth = _this.state.visibleMonth;
      var newVisibleMonth = new Date(visibleMonth);
      newVisibleMonth.setDate(1);
      if (action === 'prev') {
        newVisibleMonth.setMonth(visibleMonth.getMonth() - 1);
        _this.props.onPrevMonth(activeStartDate);
      } else if (action === 'next') {
        newVisibleMonth.setMonth(visibleMonth.getMonth() + 1);
        _this.props.onNextMonth(activeStartDate);
      }
      _this.setState({
        visibleMonth: newVisibleMonth
      });
      _this.setTabIndicies();
    };
    var initialDate = props.initialDate,
      initialVisibleMonth = props.initialVisibleMonth,
      _inputRef = props.inputRef,
      value = props.value;
    var _date;
    var _inputVal = '';
    var _visibleMonth;
    var _calendarPosition = {};
    if (value || initialDate) {
      _date = new Date(value || initialDate);
      _inputVal = _date.toLocaleDateString('en-US');
      _visibleMonth = _date;
    } else if (initialVisibleMonth) {
      _visibleMonth = new Date(initialVisibleMonth);
    }
    _this.state = {
      calendarPosition: _calendarPosition,
      date: _date,
      inputVal: _inputVal,
      visibleMonth: _visibleMonth
    };
    _this.inputRef = _inputRef || /*#__PURE__*/React.createRef();
    _this.datepickerRef = /*#__PURE__*/React.createRef();
    _this.componentIsMounted = false;
    _this.abortController = null;
    _this.inputIsControlled = value !== undefined;
    return _this;
  }
  var _proto = DatePicker.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _prevProps$value;
    var _this$props7 = this.props,
      errorInvalid = _this$props7.errorInvalid,
      showErrorInvalid = _this$props7.showErrorInvalid,
      displayCustomError = _this$props7.displayCustomError,
      value = _this$props7.value;
    if (showErrorInvalid !== prevProps.showErrorInvalid) {
      this.setState({
        errorMessage: showErrorInvalid ? errorInvalid : ''
      });
    }
    if (displayCustomError !== prevProps.displayCustomError) {
      this.setCustomError();
    }

    // controlled input logic:
    // update the input value and selected calendar date when the value prop changes
    if (value && (value === null || value === void 0 ? void 0 : value.toLocaleDateString()) !== ((_prevProps$value = prevProps.value) === null || _prevProps$value === void 0 ? void 0 : _prevProps$value.toLocaleDateString())) {
      var date = value;
      var inputVal = date.toLocaleDateString('en-US');
      if (inputVal !== this.state.inputVal) {
        this.setDateValue(date);
      }
    } else if (!value && value !== prevProps.value) {
      this.clearDateValue();
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    this.componentIsMounted = true;
    this.setTabIndicies();
    this.setCustomError();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.componentIsMounted = false;
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$state2 = this.state,
      calendarPosition = _this$state2.calendarPosition,
      centerDatepicker = _this$state2.centerDatepicker,
      date = _this$state2.date,
      inputVal = _this$state2.inputVal,
      errorMessage = _this$state2.errorMessage,
      showDatepicker = _this$state2.showDatepicker,
      dateSelectionAnnouncementContent = _this$state2.dateSelectionAnnouncementContent,
      visibleMonth = _this$state2.visibleMonth;
    var _this$props8 = this.props,
      alwaysOpen = _this$props8.alwaysOpen,
      calendarStyles = _this$props8.calendarStyles,
      errorLevel = _this$props8.errorLevel,
      groupClass = _this$props8.groupClass,
      highlightToday = _this$props8.highlightToday,
      infoPopoverContent = _this$props8.infoPopoverContent,
      infoPopoverProps = _this$props8.infoPopoverProps,
      inputClass = _this$props8.inputClass,
      inputID = _this$props8.inputID,
      inputPlaceholder = _this$props8.inputPlaceholder,
      inputProps = _this$props8.inputProps,
      isRequired = _this$props8.isRequired,
      label = _this$props8.label,
      optionalInputLabel = _this$props8.optionalInputLabel,
      reactCalendarProps = _this$props8.reactCalendarProps,
      showLabel = _this$props8.showLabel,
      showInput = _this$props8.showInput,
      showRequiredAsterisk = _this$props8.showRequiredAsterisk;
    var hasInfoPopover = infoPopoverContent !== null;

    /** @type {Record<string, [id: string, exists: boolean]>} */
    var ids = {
      help: ["".concat(inputID, "-help"), Boolean(errorMessage)],
      popover: ["".concat(inputID, "-popover"), hasInfoPopover]
    };
    var ariaDescribedByIds = Object.keys(ids).filter(function (key) {
      return ids[key][1];
    }).map(function (key) {
      return ids[key][0];
    });
    var hasAriaDescribedBy = ariaDescribedByIds.length > 0;
    var ErrorIcon = errorLevel === 'error' ? ErrorBoldIcon : WarningBoldIcon;
    var canUsePortal = this.canUsePortal;
    var disableOutsideClickHandler = alwaysOpen || !showDatepicker;
    var calendarMarkup = /*#__PURE__*/React.createElement(OutsideClickHandler, {
      onOutsideClick: this.hideDatepicker,
      disabled: disableOutsideClickHandler
    }, /*#__PURE__*/React.createElement("div", {
      ref: this.datepickerRef,
      className: classnames('asc-datepicker-calendar', {
        'asc-datepicker-calendar--static': alwaysOpen,
        'asc-datepicker-calendar--toggled': !alwaysOpen,
        'asc-datepicker-calendar--centered': centerDatepicker,
        'asc-datepicker-calendar--fixed': canUsePortal
      }),
      style: _objectSpread(_objectSpread({}, calendarStyles), calendarPosition),
      onKeyDown: function onKeyDown(e) {
        return _this2.handleDayPickerOnTab(e);
      }
    }, /*#__PURE__*/React.createElement(Calendar, _extends({
      value: date,
      onChange: function onChange(date) {
        _this2.setCustomError();
        _this2.setDateValue(date);
      },
      nextLabel: /*#__PURE__*/React.createElement(ChevronRightBoldIcon, {
        label: "Next Month"
      }),
      prevLabel: /*#__PURE__*/React.createElement(ChevronLeftBoldIcon, {
        label: "Previous Month"
      }),
      next2Label: null,
      prev2Label: null,
      calendarType: "US",
      tileDisabled: function tileDisabled(_ref2) {
        var date = _ref2.date;
        return _this2.isDayBlocked(date);
      },
      formatShortWeekday: function formatShortWeekday(locale, date) {
        return new Intl.DateTimeFormat('en-US', {
          weekday: 'long'
        }).format(date).substring(0, 2).toUpperCase();
      },
      view: "month",
      maxDetail: "month",
      minDetail: "month",
      onActiveStartDateChange: this.onActiveStartDateChange,
      activeStartDate: visibleMonth
    }, reactCalendarProps))));
    return /*#__PURE__*/React.createElement("div", {
      className: "asc-datepicker-react-dates"
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames('asc-form-group', groupClass, _defineProperty({
        'highlight-today': highlightToday
      }, "asc-form-input--".concat(errorLevel), errorMessage))
    }, /*#__PURE__*/React.createElement("label", {
      className: classnames('asc-form-label', {
        'asc-acc-hidden': !showLabel
      }),
      htmlFor: inputID
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames({
        'is-required': isRequired
      })
    }, label), showRequiredAsterisk && isRequired && /*#__PURE__*/React.createElement("span", {
      className: "asc-form-required-asterisk"
    }, "\xA0*"), !isRequired && optionalInputLabel && /*#__PURE__*/React.createElement("span", null, "\xA0", optionalInputLabel)), hasInfoPopover && /*#__PURE__*/React.createElement(FormLabelPopover, {
      messagePopoverId: ids.popover[0],
      messagePopoverContent: infoPopoverContent,
      messagePopoverProps: infoPopoverProps
    }), /*#__PURE__*/React.createElement("div", {
      className: "asc-acc-hidden",
      "aria-live": "polite",
      "aria-atomic": "true"
    }, dateSelectionAnnouncementContent), /*#__PURE__*/React.createElement("div", {
      className: classnames('asc-datepicker-input', {
        'asc-acc-hidden': !showInput
      })
    }, /*#__PURE__*/React.createElement("input", _extends({
      "aria-describedby": hasAriaDescribedBy ? ariaDescribedByIds.join(' ') : null,
      autoComplete: "off",
      ref: this.inputRef,
      id: inputID,
      className: classnames('asc-form-input', inputClass),
      pattern: "\\d{1,2}/\\d{1,2}/\\d{4}",
      placeholder: inputPlaceholder,
      onBlur: this.handleInputBlur,
      onChange: this.handleInputChange,
      onFocus: this.handleInputFocus,
      onKeyDown: this.handleInputKeydown,
      value: inputVal,
      required: isRequired,
      type: showInput ? 'text' : 'hidden'
    }, inputProps)), alwaysOpen && /*#__PURE__*/React.createElement("span", {
      className: "asc-datepicker-icon"
    }, /*#__PURE__*/React.createElement(CalendarIcon, {
      size: "sm"
    })) || /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "asc-datepicker-icon",
      onClick: this.handleIconClick
    }, /*#__PURE__*/React.createElement(CalendarIcon, {
      label: "Open datepicker calendar",
      size: "sm"
    }))), errorMessage && /*#__PURE__*/React.createElement("div", {
      id: ids.help[0],
      className: "asc-form-help"
    }, /*#__PURE__*/React.createElement(ErrorIcon, {
      className: "asc-form-help-icon",
      customSize: "14px",
      color: errorLevel
    }), /*#__PURE__*/React.createElement("p", {
      className: "asc-form-help--error-message"
    }, errorMessage)), (alwaysOpen || showDatepicker) && (canUsePortal ? /*#__PURE__*/createPortal(calendarMarkup, document.body) : calendarMarkup)));
  };
  _createClass(DatePicker, [{
    key: "canUsePortal",
    get: function get() {
      var _this$props9 = this.props,
        alwaysOpen = _this$props9.alwaysOpen,
        usePortal = _this$props9.usePortal;
      return !alwaysOpen && usePortal && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object';
    }
  }]);
  return DatePicker;
}(Component);
DatePicker.propTypes = {
  /**
   * Show the datepicker at all times
   **/
  alwaysOpen: PropTypes.bool,
  /**
   * Blocked dates
   **/
  blockedDates: PropTypes.arrayOf(PropTypes.string),
  /**
   * Option for indicating whether weekend dates should be blocked or not
   */
  blockWeekends: PropTypes.bool,
  /**
   * Custom inline styles for the calendar container
   */
  calendarStyles: PropTypes.object,
  /**
   * Close datepicker when a date is selected.<br>
   * **Note:** this option is only supported when `alwaysOpen` is set to `false`
   */
  closeOnDateSelection: PropTypes.bool,
  /**
   * Custom error message to be displayed when displayCustomError is true
   **/
  customErrorMessage: PropTypes.string,
  /**
   * Toggle to turn on the custom error message
   **/
  displayCustomError: PropTypes.bool,
  /**
   * The severity of the input's error state
   */
  errorLevel: PropTypes.oneOf(['error', 'warning']),
  /**
   * Error message displayed when a blocked date is entered
   **/
  errorBlockedDate: PropTypes.string,
  /**
   * Error message displayed when a date outside of the allowed range is entered
   **/
  errorOutsideRange: PropTypes.string,
  /**
   * Error message displayed when an invalid date is entered
   **/
  errorInvalid: PropTypes.string,
  /**
   * Error message displayed when a date is missing
   **/
  errorRequired: PropTypes.string,
  /**
   * Custom CSS classes for the wrapping .asc-form-group element
   */
  groupClass: PropTypes.string,
  /**
   * Enables a highlight style for today's date on the calendar
   */
  highlightToday: PropTypes.bool,
  /**
   * Additional classes for the input element
   */
  infoPopoverContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /**
   * Additional props to pass to the message popover component
   */
  infoPopoverProps: PropTypes.object,
  /**
   * Initial date selected (formatted date string or date object)
   */
  initialDate: PropTypes.string,
  /**
   * Initial month displayed in calendar
   **/
  initialVisibleMonth: PropTypes.string,
  /**
   * Custom CSS classes for the input element
   */
  inputClass: PropTypes.string,
  /**
   * ID attribute value for the input element
   **/
  inputID: PropTypes.string,
  /**
   * Placeholder text for the input element
   */
  inputPlaceholder: PropTypes.string,
  /**
   * Additional pass-through props for the input element
   */
  inputProps: PropTypes.object,
  /**
   * Ref object for the input field. Can be used for validation.
   */
  inputRef: PropTypes.object,
  /**
   * Is the input required
   */
  isRequired: PropTypes.bool,
  /**
   * Label text for input element
   **/
  label: PropTypes.string,
  /**
   * Max date allowed (formatted date string or date object)
   **/
  maxDate: PropTypes.string,
  /**
   * Min date allowed (formatted date string or date object)
   **/
  minDate: PropTypes.string,
  /**
   * Event handler fired when a date is selected
   **/
  onDateSelection: PropTypes.func,
  /**
   * Event handler fired when the next month button is clicked
   **/
  onNextMonth: PropTypes.func,
  /**
   * Event handler fired when the previous month button is clicked
   **/
  onPrevMonth: PropTypes.func,
  /**
   * Appended to the text label.
   * Defaults to (optional) for non-required inputs, but can be overridden.
   */
  optionalInputLabel: PropTypes.string,
  /**
   * Additional pass-through props for the react-calendar component
   **/
  reactCalendarProps: PropTypes.object,
  /**
   * Show the datepicker when the input element receives focus<br>
   * **Note:** this option is only supported when `alwaysOpen` is set to `false`
   */
  showDatepickerOnInputFocus: PropTypes.bool,
  /**
   * Toggle visibility of the invalid error state and message
   */
  showErrorInvalid: PropTypes.bool,
  /**
   * Toggles visibility of the input element<br>
   * **Note:** this option is only supported when `alwaysOpen` is set to `true`
   **/
  showInput: PropTypes.bool,
  /**
   * Toggles visibility of the input label
   */
  showLabel: PropTypes.bool,
  /**
   * Append asterisk to label
   */
  showRequiredAsterisk: PropTypes.bool,
  /**
   * Use portal to render datepicker at the end of the document. Helpful
   * when the datepicker is inside a container with overflow: hidden
   */
  usePortal: PropTypes.bool,
  /**
   * Control the input value from outside the component.
   * Must be used in conjunction with `onDateSelection`.
   */
  value: PropTypes.instanceOf(Date)
};
DatePicker.defaultProps = {
  alwaysOpen: false,
  blockedDates: [],
  blockWeekends: false,
  calendarStyles: {},
  closeOnDateSelection: false,
  displayCustomError: false,
  errorLevel: 'error',
  errorBlockedDate: 'Date is not available',
  errorInvalid: 'Date must be formatted correctly',
  errorOutsideRange: 'Date is outside of allowed range',
  errorRequired: 'This field is required',
  groupClass: '',
  highlightToday: true,
  infoPopoverContent: null,
  infoPopoverProps: {},
  initialVisibleMonth: new Date().toLocaleDateString('en-US'),
  inputClass: '',
  inputID: 'datePicker',
  inputPlaceholder: 'mm/dd/yyyy',
  inputProps: {},
  isRequired: true,
  label: 'Date',
  onDateSelection: function onDateSelection() {},
  onNextMonth: function onNextMonth() {},
  onPrevMonth: function onPrevMonth() {},
  optionalInputLabel: '(optional)',
  reactCalendarProps: {},
  showDatepickerOnInputFocus: false,
  showErrorInvalid: false,
  showLabel: true,
  showInput: true,
  showRequiredAsterisk: false,
  usePortal: false
};
export default DatePicker;